import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';






function ClassReport(props) {

  let { } = props;


  const { userData, api, refClass, classData, } = useContext(DataContext);
  const userRole = userData.role;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);



  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', classId: null, fromDate: today, toDate: today, });

  const table = 'classReport';
  const title = 'classReport';

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refClass();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const classOptions = classData.map(item => ({
    value: item.id,
    label: `${item.name} (${item.trainer?.name || 'No Trainer'})`,
  }));
  classOptions.push({ value: null, label: 'All Classes' })



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        account: item.account?.name,
      };

      transformedData.push(newItem);
    });

    return transformedData;
  };





  let newColumnDefs = [
    { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Barcode', dataIndex: 'member', render: (member) => (member?.barcode) },
    { title: 'member', dataIndex: 'member', render: (member) => (member?.name) },
    { title: 'class', dataIndex: 'class', render: (e) => (e?.name) },
    { title: 'trainer', dataIndex: 'trainer', render: (trainer) => (trainer?.name) },
    { title: 'type', dataIndex: 'type', render: typeFormatter },
    { title: 'price', dataIndex: 'usd', width: '8%' },
  ];



  useEffect(() => {

    setColumnDefs(newColumnDefs);

  }, [filter.isActive]);


  const formView = (<></>);





  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>

        <span className='table-footer footer-one'>Visits:   {numberFormatter(data?.summary?.visitCount, 2)}</span>
        <span className='table-footer footer-one'> Memberships:  {numberFormatter(data?.summary?.membershipCount, 2)} </span>
        <span className='table-footer footer-green'> Balance:  {numberFormatter(data?.summary?.totalIn + data?.summary?.totalCredit, 2)} </span>
      </div>
    </div>
  );


  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <DatePicker setFilter={setFilter} filter={filter} />



            <DataFilter selectedOption={classOptions?.find(option => option.value === filter.classId)}
              setFilter={setFilter} dataOptions={classOptions} filterBy={'classId'} placeHolder={'All Classes'} />




          </div>



          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

        </>
      }

    </div>
  )
}

export default ClassReport;
